import { lazy } from 'react';

/**
 * The Requests list's lazily loaded row actions (HS-1548 R2-4) and assignee picker (HS-1542).
 *
 * A data-screen definition is imported by its route's `validateSearch`, which is not code-split,
 * so everything the definition imports lands in the initial bundle. The row actions — the table
 * menu and the mobile card's — carry the archive mutations, the error mapping and the delete
 * dialog, and the assignee picker carries the assign mutation and the assignees read, so they are
 * loaded on demand instead, which keeps `initial JS` within its budget. The
 * route's loader starts the import alongside the list request, so it is normally in place by the
 * time the rows render.
 */
const loadRowActions = () => import('./RowActions');
const loadCardActions = () => import('./CardActions');
const loadRequestAssignee = () => import('./assignment/RequestAssignee');

export const LazyRowActions = lazy(loadRowActions);
export const LazyCardActions = lazy(loadCardActions);
export const LazyRequestAssignee = lazy(loadRequestAssignee);

/**
 * Start loading the list's lazy parts; called by the route loader. A failed preload is swallowed
 * so it cannot surface as an unhandled rejection: the render imports again through `lazy()`, and a
 * stale deploy is recovered by `chunkReload.ts`.
 */
export function preloadServiceRequestsList(): void {
  loadRowActions().catch(() => undefined);
  loadCardActions().catch(() => undefined);
  loadRequestAssignee().catch(() => undefined);
}
